export interface IAttachedFile {
  id: number;
  cleanedId?: number | null;
  context: string;
  createdAt: string;
  isCleaned: boolean;
  isStp?: boolean | null;
  name: string;
  parentId?: number | null;
  uid?: string | null;
  url: string | null;
  mediumUrl?: string | null;
  largeUrl?: string | null;
  description?: string;
}

export enum AttacheFileContext {
  Default = 'default',
  XomIqe = 'xom_iqe',
  Additional = 'additional',
  Original = 'original',
  Custom = 'custom',
  LogisticInvoiceSource = 'logistic_invoice_source',
}

export enum IAttachedFileContext {
  default = 'default',
  preQuote = 'preQuote',
  protocol = 'protocol',
  custom = 'custom',
  original = 'original',
  xomPreview = 'xomPreview',
  additional = 'additional',
  deliveryReport = 'deliveryReport',
  deliveryLabel = 'deliveryLabel',
  shippingDeliveryNote = 'shippingDeliveryNote',
  shippingPackagingReport = 'shippingPackagingReport',
  shippingLabel = 'shippingLabel',
  qualityControlCanvas = 'quality_control_canvas',
  qualityContorlMeasurementsPreview = 'quality_control_measurements_preview',
}
